import { useWalletTokensQuery, type WalletTokenMap } from '@/hooks/useWalletTokensQuery';
import { logger } from '@/lib/logger';
import { createContext, useEffect } from 'react';

interface ITokenContext {
  availableToken: WalletTokenMap;
  fetchWalletTokens: () => Promise<void>;
  isFetching: boolean;
}

const TokenContext = createContext<ITokenContext | undefined>(undefined);

const TokenContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const walletTokensQuery = useWalletTokensQuery();
  const availableToken = walletTokensQuery.data ?? {};

  const fetchWalletTokens = async () => {
    await walletTokensQuery.refetch();
  };

  useEffect(() => {
    if (walletTokensQuery.error) {
      logger.error('Error fetching wallet tokens:', walletTokensQuery.error);
    }
  }, [walletTokensQuery.error]);

  return (
    <TokenContext.Provider
      value={{
        isFetching: walletTokensQuery.isLoading || walletTokensQuery.isFetching,
        availableToken,
        fetchWalletTokens,
      }}
    >
      {children}
    </TokenContext.Provider>
  );
};

export { TokenContext, TokenContextProvider };
